<template>
    <article v-loading="loading">
        <slot :data="slotData"></slot>
        <div class="row">
            <div class="col text-center">
                <button class="btn btn-default btn-success load-more" :disabled="disabledLoadMore" @click="loadMore">Load More</button>
            </div>
        </div>
    </article>
</template>

<script>
    export default {
        mounted() {
            this.total = this.totalClean;
            this.jobs = this.initialPayload.length ? this.initialPayload : [];
            prolitEvents.$on('filterJobsChanges',ev=>{
                this.applyFilter(ev);
            });
            eventsBuffer.$on('changedGridType', ev=>{
                this.gridType=ev.type
            });
            eventsBuffer.$on('clearFilter', ev=>{
                this.appliedFilters = {};
                this.loadMore();
            });
        },
        props: {
            initialPayload: {
                default() {
                    return []
                }
            },
            totalClean: {
                default: 0
            }
        },
        data() {
            return {
                jobs: [],
                loading: false,
                current_page: 1,
                next_page: 2,
                per_page:12,
                gridType:'grid',
                appliedFilters:{},
                total:0
            };
        },
        computed: {
            slotData() {
                return {
                    jobs: this.jobs,
                    grid: this.gridType,
                }
            },
            route() {
                return window.App.routes.api.jobs;
            },
            params() {
                let params= {
                    typetag : 'jobs',
                    per_page: 12,
                    page: this.next_page
                };
                if(!Object.keys(this.appliedFilters).length){
                    return {
                        params
                    }
                }

                return {params:{...params,...this.appliedFilters}}
            },
            disabledLoadMore(){
                return !(this.total > (this.current_page*this.per_page));
            }
        },
        methods: {
            loadMore() {
                this.loading = true;
                axios.get(this.route, this.params).then(response => {
                    this.jobs = this.jobs.concat(response.data.data.data);
                    this.loading = false;
                    this.current_page = response.data.data.links.pagination.current_page;
                    this.next_page = response.data.data.links.pagination.current_page + 1;
                    this.total = response.data.data.links.pagination.total;
                }).catch(e => {
                    console.log(e)
                    this.loading = false;
                });
            },
            applyFilter(data){
                if(data.value === ""){
                    delete(this.appliedFilters[data.filter])
                }else{
                    this.appliedFilters[data.filter]=data.filter === 'sort' ? data.value+'|asc' : data.value;

                }
                this.jobs=[];
                this.current_page=0;
                this.next_page=1;
                this.loadMore();
            }
        }
    }
</script>

<style scoped>
    .container-filters {
        float: left;
        width: 100%;
        background: #F5F8F9;
    }
    .card-deck .card {
        margin: 0;
    }
    .panel-header {
    }
    .filter-container {
        padding: 10px 0;
    }
    .filter-container label {
        color: white;
        font-weight: bold;
    }
    .panel .panel-body {
        padding: 20px 0px;
    }
</style>



// WEBPACK FOOTER //
// resources/assets/js/views/jobs/JobsPage.vue